import { combineReducers } from '@ngrx/store';

import { isLoadingHomeItemDetailReducer as isLoadingHomeItemDetail } from './is-loading-home-item-detail.reducer';

export const UiHomeItemDetailRootReducer = combineReducers({
  isLoadingHomeItemDetail  
});
